import { WebserviceUrl } from "@tm/data/webserviceUrls"
import { ajaxAuth } from "@tm/utils"
import { AccessoryKitArticleRequest, Article } from "@tm/models"

export function getAccessoryKitArticle(request: AccessoryKitArticleRequest): Promise<Article> {
    const url = `${WebserviceUrl.WheelsRims}/GetAccessoryKitArticle`

    return ajaxAuth({ url, body: request, method: "GET" })
        .then((response) => response.accessoryKitArticle ?? {})
        .catch((error) => {
            if (error.message.includes("404") || error.response?.status === 404) {
                return []
            }
        })
}
